// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3ENkM","load1":"Spinner_load1__J34hm"};